import { isClient } from '../ssr/is-client';
import { createMemoryStorage } from './create-memory-storage';
/**
 * A wrapper around localStorage that falls back to memory storage in sever applications.
 */
export const localOrMemoryStorage = isClient() ? localStorage : createMemoryStorage();
//# sourceMappingURL=local-or-memory-storage.js.map